<div class="edit-page-root-container employee-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" (click)="navBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission?.can_edit || true){
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button> -->
        }
      </div>
    </div>

    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <mat-tab-group animationDuration="0ms" style="width:100%;" [(selectedIndex)]="selectedTabIndex">
              <mat-tab label="Employee">
                <div class="employee-details-grid" style="padding-top: 20px;">
                  <mat-form-field class="employee-field code-field">
                    <mat-label>Code</mat-label>
                    <input matInput formControlName="code" maxlength="50" appCodeInput>
                    <mat-error *ngIf="editForm.get('code')?.hasError('required') && editForm.get('code')?.touched">
                      Code is required.
                    </mat-error>
                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                      10.</mat-error>
                  </mat-form-field>

                  <mat-form-field class="employee-field fname-field">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="f_name">
                    <mat-error *ngIf="editForm.get('f_name')?.hasError('required') && editForm.get('f_name')?.touched">
                      First Name is required.
                    </mat-error>
                    <mat-error *ngIf="editForm.controls['f_name'].hasError('maxlength')">Maximum length is
                      50.</mat-error>
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Middle Name</mat-label>
                    <input matInput formControlName="m_name">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="l_name">
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Preferred Name</mat-label>
                    <input matInput formControlName="preferred_name">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Display Name</mat-label>
                    <input matInput formControlName="display_name">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Full Name</mat-label>
                    <input matInput formControlName="full_name">
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Gender</mat-label>
                    <input matInput formControlName="gender" readonly>
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Sort Order</mat-label>
                    <input matInput type="number" formControlName="sort_order">
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Status</mat-label>
                    <input matInput formControlName="employee_status" readonly>
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Job Position</mat-label>
                    <input matInput formControlName="job_position">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Job Title</mat-label>
                    <input matInput formControlName="job_title">
                  </mat-form-field>

                  <mat-form-field class="employee-field card-field">
                    <mat-label>Card No</mat-label>
                    <input matInput formControlName="card_no">
                    <mat-error
                      *ngIf="editForm.get('card_no')?.hasError('required') && editForm.get('card_no')?.touched">
                      Card No is required.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Cost per Hour</mat-label>
                    <input matInput type="number" formControlName="cost_per_hour">
                    <mat-error
                      *ngIf="editForm.get('cost_per_hour')?.hasError('required') && editForm.get('cost_per_hour')?.touched">
                      Cost per Hour is required.
                    </mat-error>
                    <mat-error
                      *ngIf="editForm.get('cost_per_hour')?.hasError('negative') && editForm.get('cost_per_hour')?.touched">
                      Value cannot be negative.
                    </mat-error>
                  </mat-form-field>
                  <!-- Work Hours -->
                  <mat-form-field class="employee-field">
                    <mat-label>Min Work Hours</mat-label>
                    <input matInput type="number" formControlName="min_work_hours">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Max Work Hours</mat-label>
                    <input matInput type="number" formControlName="max_work_hours">
                  </mat-form-field>

                  <div class="employee-field">
                    <br />
                    <mat-checkbox formControlName="is_partner">Is Partner</mat-checkbox>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Address">
                <div class="personnel-details-section">
                  <div class="address-section">
                    <div class="address-title">Contact Details</div>
                    <div class="address-fields">
                      <mat-form-field class="address-field">
                        <mat-label>Work Phone</mat-label>
                        <input matInput formControlName="work_phone">
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Daytime Phone</mat-label>
                        <input matInput formControlName="phone_daytime">
                      </mat-form-field>
                      <mat-form-field class="address-field full-width">
                        <mat-label>Work Email</mat-label>
                        <input matInput formControlName="work_email">
                      </mat-form-field>
                      <mat-form-field class="address-field full-width">
                        <mat-label>Personal Email</mat-label>
                        <input matInput formControlName="email">
                        <mat-error *ngIf="editForm.get('email')?.hasError('email') && editForm.get('email')?.touched">
                          Please enter a valid email address.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Mobile Phone</mat-label>
                        <input matInput formControlName="phone">
                        <mat-error *ngIf="editForm.get('phone')?.hasError('pattern') && editForm.get('phone')?.touched">
                          Please enter a valid phone number (digits only).
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Payroll" *ngIf="employeeInfo.id !== 0 && employeeInfo.id !== undefined">
                <div class="payroll-details-section" style="padding: 20px;">

                  <div class="input-group" style="display: flex; gap: 20px; align-items: center;">
                    <mat-form-field style="flex: 1;">
                      <mat-label>Payroll Code</mat-label>
                      <input matInput formControlName="payroll_code">
                      <mat-error *ngIf="editForm.controls['payroll_code'].hasError('required')">
                        Payroll Code is required
                      </mat-error>
                      <mat-error
                        *ngIf="editForm.controls['payroll_code'].hasError('minlength') || editForm.controls['payroll_code'].hasError('maxlength')">
                        must be exactly 7 characters long
                      </mat-error>
                    </mat-form-field>

                    <div style="flex: 1;">
                      <mat-checkbox formControlName="can_export">Fixed Pay</mat-checkbox>
                    </div>
                  </div>
                </div>
              </mat-tab>

              <mat-tab label="Shops">
                <div class="detail-section">
                  <div class="content-container">

                    <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px;">
                      <!-- Area (city) dropdown filter -->
                      <mat-form-field appearance="fill" style="width: 300px;">
                        <mat-label>Area</mat-label>
                        <mat-select [multiple]="true" [(value)]="selectedAreas"
                          (selectionChange)="onAreaSelectionChange($event.value)" [placeholder]="'All Areas'">
                          <mat-select-trigger>
                            {{selectedAreas.length === areaList.length ? 'All Areas' : selectedAreas.join(', ')}}
                          </mat-select-trigger>
                          <mat-option *ngFor="let area of areaList" [value]="area">{{ area }}</mat-option>
                        </mat-select>
                        <button *ngIf="selectedAreas.length" mat-icon-button matSuffix aria-label="Clear"
                          (click)="onAreaSelectionChange([]); $event.stopPropagation();">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </mat-form-field>

                      <div class="search-input-container" style="margin-top: -15px;">
                        <div class="free-search">
                          <button mat-button class="search-icon">
                            <mat-icon>search</mat-icon>
                          </button>

                          <div class="search-input">
                            <input matInput placeholder="Search..." [(ngModel)]="shopSearch"
                              [ngModelOptions]="{ standalone: true }" (ngModelChange)="onShopSearchChange($event)"
                              autocomplete="off" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="shop-cards-list">
                      <div *ngFor="let shop of sortedShopEmployeeMapping; let i = index; trackBy: trackByShop"
                        class="shop-card" [ngClass]="{'selected-shop': isShopChecked(shop)}"
                        (click)="onShopCheckboxChange(shop, !isShopChecked(shop))">

                        <div class="shop-card-left">
                          <div class="shop-avatar" [ngClass]="'color-' + (i % 4)">
                            <mat-icon>storefront</mat-icon>
                          </div>
                        </div>

                        <div class="shop-card-main">
                          <div class="shop-card-header">
                            <span class="shop-name">{{ shop.name }}</span>
                            <span class="primary-badge" *ngIf="shop.is_primary">PRIMARY SHOP</span>
                          </div>

                          <div class="shop-card-details">
                            <div class="detail-col">
                              <span class="detail-label">Area</span>
                              <span class="detail-value">{{ shop.city || '-' }}</span>
                            </div>
                            <div class="detail-col">
                              <span class="detail-label">Start Date</span>
                              <span class="detail-value">{{ (shop.start_date | date:'dd MMM yyyy') || '-' }}</span>
                            </div>
                            <div class="detail-col">
                              <span class="detail-label">End Date</span>
                              <span class="detail-value">{{ (shop.end_date | date:'dd MMM yyyy') || '-' }}</span>
                            </div>
                            <div class="detail-col notes-col">
                              <span class="detail-label">Notes</span>
                              <span class="detail-value" style="display: flex; align-items: center; gap: 8px;">
                                {{ shop.notes || '-' }}
                                <!-- <button *ngIf="shop.notes" mat-icon-button
                                  (click)="showNotes(shop); $event.stopPropagation();"
                                  style="width: 24px; height: 24px; line-height: 24px;">
                                  <mat-icon style="font-size: 16px; color: #1976d2;">info</mat-icon>
                                </button> -->
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>

            </mat-tab-group>



          </div>
        </div>







      </form>
    </div>
  </div>
</div>